export default __webpack_public_path__ + "static/media/all.90398e9a.png";